import TableCell from '@mui/material/TableCell'
import clsx from 'clsx'

const COMMON_HEADERS = [
	<TableCell className='stats' key='s' style={{ width: '10%' }}>
		Status
	</TableCell>,
	<TableCell className='contacts' key='i' style={{ width: '10%' }}>
		Invites sent
	</TableCell>,
	<TableCell className='contacts' key='a' style={{ width: '10%' }}>
		Acceptance rate
	</TableCell>,
	<TableCell className='contacts' key='m' style={{ width: '10%' }}>
		Messages sent
	</TableCell>,
	<TableCell className='contacts' key='r' style={{ width: '10%' }}>
		Reply rate
	</TableCell>
]

export function LastHeaders({ hasScroll }: { hasScroll?: boolean }) {
	return (
		<>
			{COMMON_HEADERS}

			<TableCell className='date-reply ' style={{ width: '11%' }}>
				<div
					className={clsx(
						'width-with_scroll-campaigns',
						hasScroll ? 'title-padding-scroll' : 'title-padding'
					)}
				>
					Created
				</div>
			</TableCell>
		</>
	)
}
